import { numify } from 'numify';
/////////////////////////////////////////////////////////////
import { CoinImage } from '@/app/shared/components';
interface LevelInfoItemProps {
	level: number;
	name: string;
	friendReward: number;
	//	premiumReward: number;
	image: string;
	gradient: string;
}

export const LevelInfoItem: React.FC<LevelInfoItemProps> = ({
	level,
	name,
	friendReward,
	// premiumReward,
	image,
	gradient,
}: LevelInfoItemProps) => {
	/*********************
	// #region Redux
	**********************/

	/*********************
	// #region Template
	**********************/
	return (
		<div
			className={`grid grid-cols-4 rounded-xl items-center ${gradient} pr-2`}
		>
			<div className="col-span-1 ">
				<div className="flex items-center gap-2 ">
					<div className="rounded-full p-1 col-span-2">
						<img className="w-[70px]" src={image} alt={name} />
					</div>
				</div>
			</div>
			<div className="col-span-2 pl-2">
				<p className="font-bold text-sm">
					{level} - {name}
				</p>
			</div>
			<div className="flex items-center gap-2">
				<CoinImage />
				<p>+{numify(friendReward)}</p>
			</div>
		</div>
	);
};
